import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { styled } from "@mui/material";
import type { IconButtonProps } from "@mui/material/IconButton";
import IconButton from "@mui/material/IconButton";
import type { FC } from "react";

const ExpandedIconButton = styled(IconButton)<IconButtonProps>(() => ({
  marginLeft: "auto",
  transform: "rotate(180deg)",
}));

const CollapsedIconButton = styled(IconButton)<IconButtonProps>(({ theme }) => ({
  transform: "rotate(0deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

interface Props {
  readonly expanded: boolean;
  readonly onChange: (expanded: boolean) => void;
}

const ExpandButton: FC<Props> = ({ expanded, onChange }) =>
  expanded ? (
    <ExpandedIconButton
      onClick={(e) => {
        e.stopPropagation();
        onChange(!expanded);
      }}
      aria-label="zwiń"
    >
      <ExpandMoreIcon />
    </ExpandedIconButton>
  ) : (
    <CollapsedIconButton
      onClick={(e) => {
        e.stopPropagation();
        onChange(!expanded);
      }}
      aria-label="rozwiń"
    >
      <ExpandMoreIcon />
    </CollapsedIconButton>
  );

export default ExpandButton;
